<template>
  <div class="base_box">
    <div class="t_head">
      <div class="title_box">
        <span class="logo">
          <img src="@/assets/img/logo.png" alt />
        </span>
        <span class="title">{{$t("common.name")}} </span>
      </div>
      <div class="menu">
        <!-- <div :class="{select:selectMark == i? true:false}" v-for="(item, i) in menuList" :key="i" @click="toPage(item.url,i)"> -->
        <div v-for="(item, i) in menuList" :key="i" @click="toPage(item.url,i)">
          <i :class="item.icon"></i>{{item.name}}
        </div>

      </div>
      <div class="login" @click.stop="loginClick()">
        <i class="el-icon-user"></i>
      </div>
      <div class="login_box" v-show="userShow">
        <ul>
          <li v-show="!user" @click="login()">
            <i class="el-icon-user"></i>
            <!-- 用户登录 -->
            <span>{{$t("menu.login")}}</span>
          </li>
          <li v-show="user" @click="userHome()">
            <i class="el-icon-user"></i>
            <!-- 个人中心 -->
            <span>{{$t("menu.personal")}}</span>
          </li>
          <li v-show="user" @click="logOut()">
            <i class="el-icon-switch-button"></i>
            <!-- 退出登录 -->
            <span>{{$t("menu.logout")}}</span>
          </li>

        </ul>
      </div>

      <div class="lang" @click.stop="langClick()">
      </div>
      <div class="lang_box" v-show="langShow">
        <el-radio-group size="mini" v-model="languageValue" :input="changeLang()">
          <el-radio class="lang_item" :label="item.value" v-for="(item, i) in languages" :key="i">
            {{item.label}}
          </el-radio>
        </el-radio-group>
      </div>

    </div>
    <!-- 移动端菜单 -->
    <div class="t_head_mobile">
      <div class="title_box" @click="mobileMenuFlag = !mobileMenuFlag">
        <span class="logo">
          <img src="@/assets/img/logo.png" alt />
        </span>
        <span class="title">世界妈祖文化交流公共信息平台2.0 </span>
      </div>

      <div class="menu_mobile" v-show="mobileMenuFlag">
        <div :class="{select:selectMark == i? true:false}" v-for="(item, i) in menuList" :key="i" @click="toPage(item.url,i)">
          <i :class="item.icon"></i>{{item.name}}
        </div>
      </div>
      <div class="login" @click.stop="loginClick()"> <i class="el-icon-user"></i></div>
      <div class="login_box" v-show="userShow">
        <ul>
          <li v-show="!user" @click="login()">
            <i class="el-icon-user"></i>
            <span>{{$t("menu.login")}}</span>
          </li>
          <li v-show="user" @click="userHome()">
            <i class="el-icon-user"></i>
            <span>{{$t("menu.personal")}}</span>
          </li>
          <li v-show="user" @click="logOut()">
            <i class="el-icon-switch-button"></i>
            <span>{{$t("menu.logout")}}</span>
          </li>
        </ul>
      </div>

      <div class="lang" @click.stop="langClick()">
      </div>
      <div class="lang_box" v-show="langShow">
        <el-radio-group size="mini" v-model="languageValue" :input="changeLang()">
          <el-radio class="lang_item" :label="item.value" v-for="(item, i) in languages" :key="i">
            {{item.label}}
          </el-radio>
        </el-radio-group>
      </div>

      <div class="menu_btn" @click="mobileMenuFlag = !mobileMenuFlag"> <i class="el-icon-s-operation"></i></div>
    </div>

    <div class="t_body roll" @click="mobileMenuFlag = false">
      <el-backtop target=".t_body"></el-backtop>
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  computed: {
    menuList() {
      return [
        { name: this.$t("menu.home"), url: "/", icon: "el-icon-house" },
        {
          name: this.$t("menu.map"),
          url: "/map",
          icon: "el-icon-map-location",
        },
        { name: this.$t("menu.bi"), url: "/bimap", icon: "el-icon-monitor" },
        {
          name: this.$t("menu.chart"),
          url: "/chart",
          icon: "el-icon-data-analysis",
        },
        {
          name: this.$t("menu.list"),
          url: "/list",
          icon: "el-icon-notebook-2",
        },
        {
          name: this.$t("menu.article"),
          url: "/articleList",
          icon: "el-icon-reading",
        },
        {
          name: this.$t("menu.message"),
          url: "/message",
          icon: "el-icon-chat-line-square",
        },
        {
          name: this.$t("menu.scripture"),
          url: "/scripture",
          icon: "el-icon-tickets",
        },
      ];
    },
  },
  data() {
    return {
      selectMark: 0,
      user: null, //用户信息
      userShow: false,
      mobileMenuFlag: false,
      visitorFlag: true,
      langShow: false,
      languageValue: "cn", //默认语言
      languages: [
        {
          value: "cn",
          label: "中文",
        },
        {
          value: "en",
          label: "English",
        },
        {
          value: "tc",
          label: "繁體",
        },
        {
          value: "jpn",
          label: "日本語",
        },
      ],
    };
  },

  created() {
    let path = sessionStorage.getItem("path");
    this.selectMark = path ? path : 0;
    this.user = JSON.parse(sessionStorage.getItem("user"));
    // this.common.getCommonData();
    this.languageValue = localStorage.getItem("language") || "cn"; //将语言存放在session里 没有则选择中文
  },

  mounted() {
    document.addEventListener("click", (e) => {
      if (e.target.className != "lang_box") {
        this.langShow = false;
      }
      if (
        e.target.className != "login_box" &&
        e.target.className != "login" &&
        e.target.className != "el-icon-user"
      ) {
        this.userShow = false;
      }
    });
  },
  methods: {
    toPage(path, i) {
      // 关闭移动菜单
      this.mobileMenuFlag = false;
      if (this.$route.path == path) {
        return;
      }

      if (this.$route.path == "/welcome" && path == "/") {
        return;
      }

      if (path.substr(0, 1) == "/") {
        this.selectMark = i;
        //未登录则去登陆
        if (i != 0 && !sessionStorage.getItem("user")) {
          this.$router.push("/login");
          return;
        }
        this.$router.push(path);
        sessionStorage.setItem("map", 1); //存放在session里
      }
      // 站外页面跳转
      else {
        window.open(path);
        // 跳转网页后，网站会到首页
        // this.$router.push("/home"); //跳转到登录页
      }
      this.activeName = "0";
    },

    loginClick() {
      this.user = JSON.parse(sessionStorage.getItem("user"));
      this.userShow = true;
      this.langShow = false;
    },
    //登录
    login() {
      if (!sessionStorage.getItem("user")) {
        this.$router.push("/login");
      } else if (this.$route.path != "/user") {
        sessionStorage.setItem("path", -1); //存放在session里
        this.selectMark = -1;
        this.$router.push("/user");
      }
    },
    userHome() {
      let user = JSON.parse(sessionStorage.getItem("user"));
      if (user.userAccount == "visitor") {
        // 当前为游客登陆，请登陆正式账号进行访问
        this.$alert(this.$t("menu.info1"), this.$t("common.tip"), {
          confirmButtonText: this.$t("common.sure"),
          callback: (action) => {},
        });
      } else {
        this.$router.push("/user");
      }
    },
    logOut() {
      let user = JSON.parse(sessionStorage.getItem("user"));
      let pardata = {
        id: user.id,
      };
      this.http.post("/user/logout", pardata).then((res) => {
        this.$Loading.hide();
        if (res.code == "0") {
          this.$message({
            // 退出登录成功
            message: this.$t("menu.info2"),
            type: "success",
          });
          sessionStorage.clear();
          this.$router.push("/");
          // Cookies.remove(token);
        } else {
          this.$message.error(res.message + "," + res.description);
        }
      });
    },

    langClick() {
      this.langShow = true;
      this.userShow = false;
    },
    changeLang() {
      localStorage.setItem("language", this.languageValue); //将语言存放在session里
      this.$i18n.locale = this.languageValue;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/_common.scss";
.base_box {
  height: 100%;
  width: 100%;
}
.t_head_mobile {
  display: none;
}
.t_head {
  z-index: 999;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: $head-height;
  box-sizing: border-box;
  box-shadow: $shadow;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  //玻璃质感
  background-color: $c-glass;
  backdrop-filter: $d-glass;
  border-bottom: $b-glass;
  font-size: $f-min;
  .title_box {
    display: flex;
    align-items: center;
    // justify-content: center;
    cursor: pointer;
    height: 100%;
    // min-width: 18rem;
    // border: 1px solid red;
    color: $c-main;
    border-radius: $m-lit;
    margin-left: $m-lit;
    // &:hover {
    //   box-shadow: $shadow;
    // }
    .logo {
      width: 1.5rem;
      height: 1.5rem;
      margin-right: 0.2rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .title {
      flex: 1;
    }
  }
  .menu {
    height: 100%;
    display: flex;
    align-items: center;
    color: $c-text-main;
    position: relative;

    div {
      display: flex;
      align-items: center;
      height: 100%;
      padding: 0 $m-min;
      box-sizing: border-box;
      // justify-content: center;
      cursor: pointer;
      i {
        margin-right: 0.2rem;
        color: $c-main;
      }
      &:hover {
        box-shadow: $shadow;
        opacity: 0.8;
        border-bottom: 2px solid $c-main;
        color: $c-main;
      }
    }
  }
  .select {
    border-bottom: 2px solid $c-main;
    color: $c-main;
  }
  .login {
    position: absolute;
    right: 3rem;
    color: $c-main;
    width: calc($head-height - 1rem);
    height: calc($head-height - 1rem);
    line-height: calc($head-height - 1rem);
    text-align: center;
    font-size: $f-mid;
    border-radius: 50%;
    border: $b-border;
    cursor: pointer;
    box-shadow: $shadow;
  }

  .login_box {
    z-index: 99;
    position: absolute;
    right: 3rem;
    top: $head-height;
    width: 7rem;
    height: auto;
    background-color: #fff;
    border-radius: $r-min;
    opacity: 0.9;
    box-shadow: $shadow;
    transition: all 0.5s;
    ul {
      margin: 0;
      padding: 0;
      li {
        margin: 0;
        padding: 0;
        padding: $m-lit;
        display: flex;
        align-items: center;
        cursor: pointer;
        i {
          margin-right: $m-lit;
          color: $c-main;
          // font-size: $f-mid;
        }
        span {
        }
        &:hover {
          color: $c-main;
          i {
            color: $c-second;
          }
        }
      }
    }
  }

  .lang {
    position: absolute;
    right: 1rem;
    width: calc($head-height - 1rem);
    height: calc($head-height - 1rem);
    cursor: pointer;
    background: url("../assets/img/lang2.png");
    background-size: 100%;
  }
  .lang_box {
    z-index: 99;
    position: absolute;
    right: 1rem;
    top: $head-height;
    width: 7rem;
    height: auto;
    background-color: #fff;
    border-radius: $r-min;
    opacity: 0.9;
    box-shadow: $shadow;
    transition: all 0.5s;
    .lang_item {
      // padding: 0.2rem;
      // padding-left: 0.6rem;
      margin: 0.2rem;
      margin-left: 0.6rem;
      box-sizing: border-box;
    }
  }
}

.t_body {
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  overflow-y: auto;
  position: relative;
  background: url("../assets/img/f2.png");
  background-color: $c-bgc;
}

@media screen and (min-width: 1021px) and (max-width: 1440px) {
  .t_head {
    .title_box {
      width: $head-height;

      .logo {
        width: 2rem;
        height: 2rem;
        // margin-right: 0.2rem;
      }
      .title {
        display: none;
      }
    }
  }
}

@media screen and (max-width: 1020px) {
  .t_head {
    display: none;
  }

  .t_head_mobile {
    display: block;
    z-index: 999;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: $head-height;
    box-sizing: border-box;
    box-shadow: $shadow;
    font-size: $f-min;
    background-color: $c-white;
    display: flex;
    align-items: center;
    justify-content: space-around;
    .title_box {
      display: flex;
      padding-left: $m-lit;
      justify-content: flex-start;
      align-items: center;
      cursor: pointer;
      font-size: $f-lit;
      height: 100%;
      width: 80%;
      color: $c-main;
      // &:hover {
      //   box-shadow: $shadow;
      // }
      .logo {
        float: left;
        width: 1.5rem;
        height: 1.5rem;
        margin-right: 0.2rem;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .menu_mobile {
      top: $head-height;
      position: absolute;
      width: 100%;
      left: 0;
      opacity: 0.5rem;
      box-shadow: $shadow;
      border-radius: 0 0 $r-mid $r-mid;
      overflow: hidden;
      div {
        height: $head-height;
        line-height: $head-height;
        padding-left: $m-mid;
        border-bottom: $b-border-light;
        color: $c-text-main;
        box-sizing: border-box;
        background-color: #fbfbfb;
        // width: 90%;
        // margin: 0 auto;
        box-shadow: $shadow;

        cursor: pointer;
        i {
          margin-right: 0.4rem;
          color: $c-main;
        }
        &:hover {
          // box-shadow: $shadow;
          opacity: 0.8;
        }
      }
    }
    .select {
      border-bottom: 2px solid $c-main;
      color: $c-main;
    }
    .login {
      color: $c-main;
      width: calc($head-height - 1rem);
      height: calc($head-height - 1rem);
      line-height: calc($head-height - 1rem);
      text-align: center;
      font-size: $f-mid;
      border-radius: 50%;
      border: $b-border;
      margin-right: $m-lit;
      cursor: pointer;
      box-shadow: $shadow;
    }

    .login_box {
      z-index: 999;
      position: absolute;
      right: 1rem;
      top: $head-height;
      width: 7rem;
      height: auto;
      background-color: #fff;
      border-radius: $r-min;
      opacity: 0.9;
      box-shadow: $shadow;
      transition: all 0.5s;
      ul {
        margin: 0;
        padding: 0;
        li {
          margin: 0;
          padding: 0;
          padding: $m-lit;
          display: flex;
          align-items: center;
          cursor: pointer;
          i {
            margin-right: $m-lit;
            color: $c-main;
            // font-size: $f-mid;
          }
          &:hover {
            color: $c-main;
            i {
              color: $c-second;
            }
          }
        }
      }
    }
    .lang {
      width: calc($head-height - 0.9rem);
      height: calc($head-height - 0.9rem);
      cursor: pointer;
      margin-right: $m-lit;
      margin-top: 0.1rem;
      background: url("../assets/img/lang2.png") no-repeat;
      background-size: 100%;
    }
    .lang_box {
      z-index: 999;
      position: absolute;
      right: 1rem;
      top: $head-height;
      width: 7rem;
      height: auto;
      background-color: #fff;
      border-radius: $r-min;
      opacity: 0.9;
      box-shadow: $shadow;
      transition: all 0.5s;
      .lang_item {
        padding: 0.2rem;
        padding-left: 0.6rem;
      }
    }
    .menu_btn {
      color: $c-main;
      font-size: $f-hug;
    }
  }
}
</style>